import React from "react";
import DisabledStarRating from "../CandidatesList/DisabledStarRating";

interface EvaluationItemProps {
  evaluation: {
    id: string;
    point: number;
    title: string;
    comment: string;
  };
  onClick: (evaluation: {
    id: string;
    point: number;
    title: string;
    comment: string;
  }) => void;
}

const EvaluationItem: React.FC<EvaluationItemProps> = ({
  evaluation,
  onClick,
}) => {
  return (
    <div
      className="flex items-center justify-between px-4 py-3 border rounded-md shadow-sm hover:bg-gray-50 cursor-pointer"
      onClick={() => onClick(evaluation)}
    >
      <div>
        <h3 className="text-md font-semibold text-gray-700">
          {evaluation.title}
        </h3>
      </div>
      <DisabledStarRating
        rating={evaluation.point}
        starColor="#f59e0b"
        emptyStarColor="#e5e7eb"
        size={24}
      />
    </div>
  );
};

export default EvaluationItem;
